import React, { type PropsWithChildren, createContext, useState } from "react";
import { Channel, type Message } from "stream-chat";

type MessageContext = {
  channel: NullableChannel;
  thread: NullableThread;
  setChannel: StateSetter<NullableChannel> | null;
  setThread: StateSetter<NullableThread> | null;
};

export const MessageContext = createContext<MessageContext>({
  channel: null,
  thread: null,
  setChannel: null,
  setThread: null,
});

type NullableChannel = Channel | null;
type NullableThread = Message | null;
type StateSetter<T> = React.Dispatch<React.SetStateAction<T>>;

export const AppProvider = ({
  children,
}: PropsWithChildren): React.JSX.Element => {
  const [channel, setChannel] = useState<NullableChannel>(null);
  const [thread, setThread] = useState<NullableThread>(null);

  return (
    <MessageContext.Provider
      value={{
        channel,
        thread,
        setChannel,
        setThread,
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageContext = (): MessageContext =>
  React.useContext(MessageContext);
